import { RibbonBar, RibbonDivider, RibbonSection, RibbonButton } from 'common/components';
import { useSelector, useDispatch } from 'react-redux';
import { DeleteOutlined, SaveOutlined, EditOutlined, CheckOutlined } from '@ant-design/icons';
import { forwardTo } from 'utils/common/route';
import { Can } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import {
  ViewLayout, OtherLayout
} from 'pages/home/ribbon/components';
import { useFolderByLevel } from 'hooks/useFolderByLevel';
import { CustomNotification } from 'common/components';

const GREvalFormRibbon = () => {

  const { keepFolderBreadcrumb } =
    useFolderByLevel();
  const closeDetailCallback = () => {
    keepFolderBreadcrumb(true);
  };

  return (
    <>
      <RibbonBar>
        <RibbonSection>
          <Can I={ABILITY_ACTION.EDIT} a={ABILITY_SUBJECT.GR_EVALUATION_FORM}>
            <RibbonButton
              icon={<SaveOutlined />}
              label="Save as Draft"
            // onClick={handleSaveDraft}
            />
          </Can>
          <Can I={ABILITY_ACTION.EDIT} a={ABILITY_SUBJECT.GR_EVALUATION_FORM}>
            <RibbonButton
              icon={<CheckOutlined />}
              label="Complete"
            // onClick={handleComplete}
            />
          </Can>
          <RibbonDivider />
          <Can I={ABILITY_ACTION.DELETE} a={ABILITY_SUBJECT.GR_EVALUATION_FORM}>
            <RibbonButton
              icon={<DeleteOutlined />}
              label="Delete"
              danger
            // onClick={handleDelete}
            />
          </Can>
        </RibbonSection>
        <OtherLayout
          ribbonSide='right'
          ribbonType='evalFormDetails'
          isHaveAddOpenItem={false}
          closeDetailCallback={closeDetailCallback}
        />
      </RibbonBar>

    </>
  );

};


export default GREvalFormRibbon;
